/* eslint-disable angular/controller-name, angular/controller-as */

angular.
module("dx.webapp.masterTools").
controller("DxMasterToolsSearchController", function MasterToolsSearchController(
	$scope,
	$location,

	NodeRepository,
	Node,
	user,
	student
) {
	// NOTE(robin): The logic in this view is flawed.
	// The search form should only set the query in the url.
	// Then the controller should listen to that and update accordingly.
	// The logic currently used is flawed since it performs two searches when you press search with a new query.
	"use strict";

	$scope.organizations = {};
	$scope.userResults = null;
	$scope.studentResults = null;

	$scope.updateFromSearch = function updateFromSearch() {
		$scope.query = $location.search();

		if ($scope.isStudentInfoInQuery()) {
			$scope.studentSearch($scope.query.studentPageToken);
		}

		if ($scope.isUserInfoInQuery()) {
			$scope.userSearch($scope.query.userPageToken);
		}
	};

	$scope.$on("$routeUpdate", $scope.updateFromSearch);

	$scope.clearUserSearch = function clearUserSearch() {
		$scope.query = {};
		$scope.userResults = null;
		return $location.search($scope.query);
	};

	$scope.clearStudentSearch = function clearStudentSearch() {
		$scope.query = {};
		$scope.studentResults = null;
		return $location.search($scope.query);
	};

	$scope.userSearch = function userSearch(pageToken) {
		$scope.query.userPageToken = pageToken;

		user.query({
			id: $scope.query.userId,
			firstName: $scope.query.userFirstName,
			lastName: $scope.query.userLastName,
			email: $scope.query.userEmail,
			pageToken: $scope.query.userPageToken,
		}).then(function success(response) {
			$scope.userResults = response.data;
			$scope.query.userPageToken = response.pageToken;
		});

		return $location.search($scope.query);
	};

	$scope.studentSearch = function studentSearch(pageToken) {
		$scope.query.studentPageToken = pageToken;

		student.query({
			id: $scope.query.studentId,
			code: $scope.query.studentCode,
			pageToken: $scope.query.studentPageToken,
		}).then(function success(response) {
			$scope.studentResults = response.data;
			$scope.query.studentPageToken = response.pageToken;

			for (var i = 0; i < $scope.studentResults.length; i++) {
				if ($scope.studentResults[i].organizationId !== 0) {
					$scope.lazyLoadOrg($scope.studentResults[i].organizationId);
				}

				if (!$scope.studentResults[i].examIds) {
					$scope.studentResults[i].examIds = [];
				}
			}
		});

		return $location.search($scope.query);
	};

	$scope.lazyLoadOrg = function lazyLoadOrg(orgId) {
		if (!$scope.organizations[orgId]) {
			$scope.organizations[orgId] = {
				title: "Loading...",
			};

			NodeRepository.load(orgId).then(function success(organization) {
				$scope.organizations[orgId] = new Node(organization);
			});
		}
	};

	$scope.isStudentInfoInQuery = function isStudentInfoInQuery() {
		return $scope.query.studentId || $scope.query.studentCode;
	};

	$scope.isUserInfoInQuery = function isUserInfoInQuery() {
		var q = $scope.query;

		return q.userId || q.userFirstName || q.userLastName || q.email;
	};

	return $scope.updateFromSearch();
});
